import { Injectable } from '@angular/core'

import { BaseBillingModel } from './base-billing.model'

@Injectable()
export class BillingUsageReportModel extends BaseBillingModel {
  protected readonly modelName = 'TiBillingUsageReportModel'

  public tspId!: number
  public year = new Date().getUTCFullYear()
  public month = new Date().getUTCMonth()

  async load() {
    if (!this.tspId || !this.year || (!this.month && this.month != 0)) {
      console.warn('Invalid billing period input', {
        tsp: this.tspId,
        month: this.month,
        year: this.year,
      })
      return
    }
    this.store.isLoading$.next(true)
    const invoice = await this.api.ti.billing.getUsage(this.tspId, this.year, this.month)
    this.applyBillingMode(invoice)
    this.invoice$.next(invoice)
    this.refresh()
    this.store.isLoading$.next(false)
  }

  clearHistory() {
    this.store.loadedPages.clear()
    this.invoice$.next(null)
  }
}
